'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _biddingInfo = require('./mock/biddingInfo');

var _biddingInfo2 = require('./remote/biddingInfo');

var BiddingInfo = {
    fetchCatalogBidding: function fetchCatalogBidding(params) {
        return __MOCK__ ? _biddingInfo.BiddingInfoMock.fetchCatalogBidding(params) : _biddingInfo2.BiddingInfoRemote.fetchCatalogBidding(params);
    },
    fetchItemBidding: function fetchItemBidding(params) {
        return _biddingInfo2.BiddingInfoRemote.fetchItemBidding(params);
    }
};

exports.default = BiddingInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/biddingInfo.js
// module id = 1dxa
// module chunks = 46